const ProfileImage = ({ profilePic }) => {
  return (
    <>
      <div className="d-flex flex-column justify-content-center align-items-center">
        <img className="profile-img" src={profilePic} alt="profile"></img>
        <span className="label-text">Profile Image</span>
      </div>

      <style>{`
                .label-text{
                    color: var(--secondaryColor);
                    font-weight: 600;
                    font-size: 16px;
                    margin: 15px
                }
                .profile-img{
                    width: 150px;
                    height: 150px;
                    border: 1px solid var(--primaryColor);
                    padding: 3px;
                    border-radius: 50%;
            }
		`}</style>
    </>
  );
};

export default ProfileImage;
